import { render, staticRenderFns } from "./realignment-remarks.vue?vue&type=template&id=dd90c2d0&"
import script from "./realignment-remarks.vue?vue&type=script&lang=js&"
export * from "./realignment-remarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports